import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-316a2d4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "msg_center_menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "msg_center_item" }, "消息管理", -1))
const _hoisted_3 = { class: "msg_center_tbody" }
const _hoisted_4 = { class: "mod_wrap" }
const _hoisted_5 = { class: "mod_c" }
const _hoisted_6 = { class: "mod_c_title" }
const _hoisted_7 = { class: "mod_c_tbody" }
const _hoisted_8 = { class: "msg_wrap" }
const _hoisted_9 = { class: "msg_title" }
const _hoisted_10 = {
  key: 1,
  class: "mod_scoll"
}
const _hoisted_11 = { class: "msg_item_content_title mod_elip_wrap" }
const _hoisted_12 = { class: "text" }
const _hoisted_13 = { class: "msg_item_content_meta" }
const _hoisted_14 = { class: "mtcm_title" }
const _hoisted_15 = { class: "mtcm_time" }
const _hoisted_16 = {
  key: 2,
  class: "msg_pagin"
}
const _hoisted_17 = { class: "modal_msg_wrap" }
const _hoisted_18 = ["innerHTML"]

import { MsgClass, RootMsg } from '@/store/modules/home/type';
import { Pagination, Modal, Menu } from 'ant-design-vue';
import { computed, reactive, ref } from 'vue';
import { emptyDataSec } from '@/assets';
import Crumb from '@/components/Crumb.vue';
import EventBus from '@/components/EventBus';
import http from '@/api/home';
import { useRoute } from 'vue-router';
import { useDebounce } from '@/hooks/useDebounce';
import { RootModal } from '@/types/base';
import { useStore } from 'vuex';
import CLoading from '@/components/CLoading.vue';

interface MsgType {
  current: number;
  pageSize: number;
  totalSize: number;
  list: RootMsg[];
}
// 消息中心icon
interface MsgSearch {
  status?: number;
  type?: number;
}


const __default__ = { name: 'MessageAll' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const aModal = Modal;
const aPagination = Pagination;
const aMenu = Menu;
const aMenuItem = Menu.Item;
const route = useRoute();

// const store = useStore();
const pageConfig = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 0, // 总页数
  options: ['10', '20', '30', '40', '50'], // 选项
  size: 'small', // 尺寸
  showJumper: false, // 是否显示跳页
  showSize: false, // 是否显示条数切换
});
const typeArr = [
  '',
  'msg_version',
  'msg_danger',
  'msg_version',
  'msg_version',
  'msg_custom',
  'msg_version',
  '',
  '',
  'msg_welfare',
];

const menu = ref<{ type_id: number; type_name: string }[]>([]);
const count = reactive({
  allCount: 0,
  unReadCount: 0,
});
const selectedKeys = ref<string[]>([route.path]);
const setUnRead = (status: number) => {
  queryForm.status = status;
  getMsgList();
};
const showLoading = ref<boolean>(false);
const msgData = ref<MsgType>({
  current: pageConfig.current,
  pageSize: pageConfig.pageSize,
  totalSize: pageConfig.totalSize,
  list: [],
});

const queryForm = reactive<MsgSearch>({
  status: 0,
  type: 0,
});

const getMsgList = useDebounce(async () => {
  const { current, pageSize } = pageConfig;

  // if (route.params.typeId) {
  //   queryForm.type = parseInt(route.params.typeId as string);
  // }
  const searchData = new MsgClass({
    page: current,
    page_num: pageSize,
    ...queryForm,
  });
  showLoading.value = true;
  http
    .getAllMsg({ params: searchData })
    .then((res) => {
      showLoading.value = false;
      const resData = res.data.data.data;
      const { current_page, total, total_count, unread_count } = res.data.data;
      count.allCount = total_count;
      count.unReadCount = unread_count;
      msgData.value.list = resData.map((v: RootMsg) => {
        v.title = v.message.replace(/<\/?.+?>/g, '').replace('&nbsp;', '');
        return v;
      });
      pageConfig.current = current_page;
      pageConfig.totalSize = total;
      menu.value = res.data.data.menu.map((e: { type_id: number; type_name: string }) => e);
    })
    .catch((err) => {
      showLoading.value = false;
    });
});
/**
 * init 初始化
 * 路由进入前处理底部栏
 **/
const store = useStore();
store.commit('home/setCustomFooter', true);
const customData = computed(() => store.state.home.customData);
const customFootStyle = computed(() => store.state.home.customFootStyle);
getMsgList();

const handleSwitch = (id: number) => {
  msgData.value.list = [];
  queryForm.type = id;
  getMsgList();
};

const msgInfo = ref<RootMsg>();
const msgInfoRef = ref();
const infoModal = reactive<Required<RootModal>>({
  title: '消息中心',
  visible: false,
  loading: false,
  centered: true,
  width: 500,
});

const openModal = async (index: number) => {
  msgInfo.value = msgData.value.list[index];
  infoModal.title = msgData.value.list[index].type_name;
  infoModal.visible = !infoModal.visible;
  infoModal.width = document.body.clientWidth / 2;
  if (!msgInfo.value.status) {
    msgInfo.value.status = 1;
    await http.getAllMsgInfo({
      params: {
        id: msgData.value.list[index].id,
      },
    });
    EventBus.emit('updateMsgList');
  }
};
const setMsgAllRead = useDebounce(async () => {
  await http.setAllMsgread();
  await getMsgList();
  EventBus.emit('updateMsgList');
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "msg_center_wrap",
    ref_key: "msgInfoRef",
    ref: msgInfoRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_unref(aMenu), {
        theme: "light",
        mode: "inline",
        inlineIndent: 18,
        selectedKeys: selectedKeys.value,
        "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.value, (obj) => {
            return (_openBlock(), _createBlock(_unref(aMenuItem), {
              key: `/account/message/type/${obj.type_id}`,
              style: {"font-size":"13px"},
              onClick: ($event: any) => (handleSwitch(obj.type_id))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(obj.type_name), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["selectedKeys"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(Crumb),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(route).meta?.title), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createVNode(_component_a_button, {
                    type: "link",
                    class: _normalizeClass(["msg_title_operate select", { actived: queryForm.status === 0 }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (setUnRead(0)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("全部（" + _toDisplayString(count.allCount) + "）", 1)
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_a_button, {
                    type: "link",
                    class: _normalizeClass(["msg_title_operate select", { actived: queryForm.status === 1 }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (setUnRead(1)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("未读(" + _toDisplayString(count.unReadCount) + ")", 1)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _createVNode(_component_a_button, {
                  type: "link",
                  class: "msg_title_operate",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(setMsgAllRead)()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("全部已读")
                  ]),
                  _: 1
                })
              ]),
              (showLoading.value)
                ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (!showLoading.value && msgData.value.list.length === 0)
                      ? (_openBlock(), _createBlock(_component_a_empty, {
                          key: 0,
                          class: "empty_wrap",
                          image: _unref(emptyDataSec),
                          description: "页面暂无数据信息~"
                        }, null, 8, ["image"]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(msgData.value.list, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id,
                        class: "msg_item"
                      }, [
                        _createVNode(_component_svg_icon, {
                          class: "msg_item_icon",
                          "icon-class": typeArr[item.type_id]
                        }, null, 8, ["icon-class"]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["msg_item_content", item.status ? '' : 'actived'])
                        }, [
                          _createElementVNode("p", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(item.title), 1)
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(item.type_name), 1),
                            _createTextVNode("| "),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(item.created_at), 1),
                            _createVNode(_component_a_button, {
                              type: "link",
                              class: "msg_title_operate mtcm_link",
                              footer: null,
                              onClick: ($event: any) => (openModal(index))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("查看全文")
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ], 2)
                      ]))
                    }), 128))
                  ])),
              (msgData.value.list.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_unref(aPagination), {
                      "show-quick-jumper": "",
                      total: pageConfig.totalSize,
                      current: pageConfig.current,
                      "onUpdate:current": _cache[4] || (_cache[4] = ($event: any) => ((pageConfig.current) = $event)),
                      "page-size": pageConfig.pageSize,
                      "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((pageConfig.pageSize) = $event)),
                      pageSizeOptions: pageConfig.options,
                      "show-less-items": "",
                      "show-size-changer": "",
                      onChange: _unref(getMsgList),
                      onShowSizeChange: _unref(getMsgList)
                    }, null, 8, ["total", "current", "page-size", "pageSizeOptions", "onChange", "onShowSizeChange"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_unref(aModal), {
                visible: infoModal.visible,
                "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((infoModal.visible) = $event)),
                title: infoModal.title,
                centered: infoModal.centered,
                onOk: _cache[7] || (_cache[7] = ($event: any) => (infoModal.visible = false)),
                width: 800,
                footer: null
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", {
                      innerHTML: msgInfo.value?.message
                    }, null, 8, _hoisted_18)
                  ])
                ]),
                _: 1
              }, 8, ["visible", "title", "centered"])
            ])
          ])
        ])
      ]),
      _withDirectives(_createElementVNode("div", { class: "mod_footer" }, _toDisplayString(_unref(customData).copyright), 513), [
        [_vShow, _unref(customFootStyle)]
      ])
    ])
  ], 512))
}
}

})